module.exports = __webpack_public_path__ + "static/media/mulan.cf22d699.png";